import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { translationChunksConfig, translations } from '@spartacus/assets';
import {
  OccConfig,
  provideConfig,
  provideFeatureToggles,
} from '@spartacus/core';
import {
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from 'src/environments/environment';

const occConfig: OccConfig = { backend: { occ: {} } };
// only provide the `occ.baseUrl` key if it is explicitly configured, otherwise the value of
// <meta name="occ-backend-base-url" > is ignored.
// This in turn breaks the deployment in CCv2.
// https://github.com/SAP/spartacus/issues/5886
occConfig.backend.occ.prefix = '/occ/v2/';
if (environment.occBaseUrl) {
  occConfig.backend.occ.baseUrl = environment.occBaseUrl;
}

const PRODUCT_TYPE = 'DEFAULT';

@NgModule({
  declarations: [],
  imports: [BrowserModule],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: occConfig.backend,
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        // TODO: adjust origins as necessary
        allowOrigin:
          'localhost:9002, *.*.model-t.cc.commerce.ondemand.com:443, *.pharma.aventis.com:443, *.sanofiecomm.com:443',
      },
      context: {
        urlParameters: ['baseSite', 'language', 'currency'],
        baseSite: ['vsca'],
        currency: ['CAD'],
        language: ['en', 'fr'],
      },
      i18n: {
        resources: translations,
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
      features: {
        level: '6.0',
      },
    }),
    provideConfig({
      backend: {
        occ: {
          endpoints: {
            asmCustomerSearch: '/occ/v2/vsca/assisted-service/customers/search',
            product: {
              default:
                'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(DEFAULT),baseOptions,baseProduct,variantOptions,variantType',
              details:
                'products/${productCode}?fields=averageRating,stock(DEFAULT),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(BASIC,name,url),priceRange,multidimensional,tags,images(FULL)',
            },
            productSearch: `products/search?fields=products(${PRODUCT_TYPE},images(DEFAULT)),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery`,
            // product:'products/${productCode}?fields=code,name,summary,price(formattedValue,DEFAULT),images(galleryIndex,FULL),baseProduct,averageRating,stock(DEFAULT),description,availableForPickup,url,numberOfReviews,manufacturer,categories(BASIC),priceRange,multidimensional,tags,DEFAULT,classifications,baseOptions,variantOptions,variantType',
            // product: {
            //   default:
            //     'products/${productCode}?fields=DEFAULT,averageRating,images(FULL),classifications,manufacturer,numberOfReviews,categories(DEFAULT),baseOptions,baseProduct,variantOptions,variantType',
            //   details:
            //     'products/${productCode}?fields=averageRating,stock(DEFAULT),description,availableForPickup,code,url,price(DEFAULT),numberOfReviews,manufacturer,categories(BASIC),priceRange,multidimensional,tags,images(FULL)',
            // },
          },
        },
      },
    } as OccConfig),
    provideFeatureToggles({
      searchBoxV2: false,
      enableClaimCustomerCouponWithCodeInRequestBody: false,
      enableCarouselCategoryProducts: false,
      propagateErrorsToServer: false,
      ssrStrictErrorHandlingForHttpAndNgrx: false,
      a11yCartImportConfirmationMessage: false,
      a11yKeyboardAccessibleZoom: false,
      a11yPreventCartItemsFormRedundantRecreation: false,
      a11yLinkBtnsToTertiaryBtns: false,
      useSiteThemeService: false,
      enableConsecutiveCharactersPasswordRequirement: false,
      enablePasswordsCannotMatchInPasswordUpdateForm: false,
      allPageMetaResolversEnabledInCsr: false,
      a11yPreventHorizontalScroll: false,
      a11yMobileFocusOnFirstNavigationItem: false,
      a11yUseTrapTabInsteadOfTrapInDialogs: false,
      a11yTabComponent: false,
      a11yCarouselArrowKeysNavigation: false,
      a11yDeliveryMethodFieldset: false,
      a11yShowMoreReviewsBtnFocus: false,
      a11yDialogTriggerRefocus: false,
      a11yAddToWishlistFocus: false,
      a11ySearchBoxFocusOnEscape: false,
    }),
  ],
})
/*
 *  https://api.czz3177o4e-sanofiave3-d1-public.model-t.cc.commerce.ondemand.com/occ/v2/vsca
 * /products/search?fields=products(DEFAULT)%2C
 * facets%2Cbreadcrumbs%2C
 * pagination(DEFAULT)%2Csorts(DEFAULT)%2C
 * freeTextSearch%2C
 * currentQuery&query=%3Arelevance%3AallCategories%3A1&pageSize=10&lang=en&curr=CAD
 * */
export class SpartacusConfigurationModule {}
